module.exports = __webpack_public_path__ + "img/wx_app.63e76b4e.svg";